module.exports = __webpack_public_path__ + "static/img/bg.2205355.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/dialog/switchCard/bg.png
// module id = 0N4T
// module chunks = 6